import type { TokenInfo } from "../api/token-api"
import env from "@/env"

export const nativeTokenInfo: TokenInfo = {
  id: env.VITE_WRAPPED_AR_PROCESS,
  denomination: 12,
  ticker: "wAR",
  logo: "L99jaxRKQKJt9CqoJtPaieGPEhJD3wNhR4iGqc8amXs",
  name: "Wrapped AR",
}
